import {
  Directive, Input, TemplateRef, HostListener, OnInit, ElementRef, ComponentRef
} from '@angular/core';
import {
  OverlayRef,
  Overlay,
  OverlayPositionBuilder
} from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { TooltipComponent } from './tooltip.component';

@Directive({ selector: '[appTooltip]' })
export class TooltipDirective implements OnInit {
  @Input('appTooltip') content: string | TemplateRef<any>;
  private overlayRef: OverlayRef;
  isAbove: boolean;

  constructor(
    private overlayPositionBuilder: OverlayPositionBuilder,
    private elementRef: ElementRef,
    private overlay: Overlay
  ) {}

  ngOnInit() {
    const positionStrategy = this.overlayPositionBuilder
      .flexibleConnectedTo(this.elementRef)
      .withPositions([
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top',
          offsetX: 20,
          offsetY: this.getOffsetY()
        }
      ]);
    const scrollStrategy = this.overlay.scrollStrategies.close();

    this.overlayRef = this.overlay.create({ 
      positionStrategy,
      scrollStrategy,
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-dark-backdrop',
      panelClass: 'tooltip-directive'
    });

    this.overlayRef.backdropClick().subscribe(() => this.hide());
  }

  private getOffsetY() {
    if (window.innerHeight - this.elementRef.nativeElement.getBoundingClientRect().bottom < 260) {
      this.isAbove = true
      return -265;
    }
    this.isAbove = false;
    return 0;
  }

  @HostListener('click')
  open() {
    if (!this.overlayRef.hasAttached()) {
      this.show();
    }
  }

  private show() {
    this.overlayRef.updatePositionStrategy(this.overlayPositionBuilder
      .flexibleConnectedTo(this.elementRef)
      .withPositions([{
        originX: 'end',
        originY: 'bottom',
        overlayX: 'end',
        overlayY: 'top',
        offsetX: 20,
        offsetY: this.getOffsetY()
      }]));

    const tooltipPortal = new ComponentPortal(TooltipComponent);

    const tooltipRef: ComponentRef<TooltipComponent> = this.overlayRef.attach(
      tooltipPortal
    );

    if (typeof(this.content) === 'string') {
      tooltipRef.instance.text = this.content;
    } else {
      tooltipRef.instance.content = this.content;
    }
    tooltipRef.instance.isAbove = this.isAbove;
    tooltipRef.instance.onClose = () => this.hide();
  }

  private hide() {
    this.overlayRef.detach();
  }
}
